var prepareDefaultHeadTags = function (title, description) {
    return [
        {
            "tag": "title",
            "attributes": {},
            "value": title
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": title
            }
        },
        {
            "tag": "meta",
            "attributes": {"name": "description", "content": description}
        },
        {
            "tag": "meta",
            "attributes": {"property": "og:description", "content": description}
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {"property": "og:site_name", "content": "Harri"}
        }
    ];
};

var wpRoutes = {};
var header = {};

header = {
    'default': [
        {
            'id': 20497,
            'url': '#',
            'title': 'Product',
            'menu_order': 1,
            'object': 'custom',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 20498,
                    'url': '/pre-hire/',
                    'title': 'Talent Acquisition',
                    'menu_order': 2,
                    'object': 'page',
                    'menu_item_parent': '20497',
                    'description': ''
                },
                {
                    'id': 20499,
                    'url': '/post-hire/',
                    'title': 'Workforce Management',
                    'menu_order': 3,
                    'object': 'page',
                    'menu_item_parent': '20497',
                    'description': ''
                },
                {
                    'id': 20500,
                    'url': '/engagement/',
                    'title': 'Employee Engagement',
                    'menu_order': 4,
                    'object': 'page',
                    'menu_item_parent': '20497',
                    'description': ''
                }
            ]
        },
        {
            'id': 20501,
            'url': '#',
            'title': 'Platform',
            'menu_order': 5,
            'object': 'custom',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 20502,
                    'url': '/agentic-ai/',
                    'title': 'Agentic AI',
                    'menu_order': 6,
                    'object': 'page',
                    'menu_item_parent': '20501',
                    'description': ''
                },
                {
                    'id': 20503,
                    'url': '/insights-analytics/',
                    'title': 'Insights and Analytics',
                    'menu_order': 7,
                    'object': 'page',
                    'menu_item_parent': '20501',
                    'description': ''
                },
                {
                    'id': 20504,
                    'url': '/compliance/',
                    'title': 'Compliance',
                    'menu_order': 8,
                    'object': 'page',
                    'menu_item_parent': '20501',
                    'description': ''
                },
                {
                    'id': 20505,
                    'url': '/partners/',
                    'title': 'Integrations',
                    'menu_order': 9,
                    'object': 'page',
                    'menu_item_parent': '20501',
                    'description': ''
                }
            ]
        },
        {
            'id': 20506,
            'url': 'https://resources.harri.com/',
            'title': 'Resources',
            'menu_order': 10,
            'object': 'custom',
            'menu_item_parent': '0',
            'description': ''
        },
        {
            'id': 20507,
            'url': '/about-us/',
            'title': 'About Us',
            'menu_order': 11,
            'object': 'page',
            'menu_item_parent': '0',
            'description': ''
        }
    ],
    'uk': [
        {
            'id': 11098,
            'url': '/platform/',
            'title': 'Products & Solutions',
            'menu_order': 1,
            'object': 'page',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 7148,
                    'url': '/pre-hire/',
                    'title': 'Talent Acquisition',
                    'menu_order': 2,
                    'object': 'page',
                    'menu_item_parent': '11098',
                    'description': 'Talent solutions to source, attract, and hire your teams.',
                    'children': [
                        {
                            'id': 7149,
                            'url': '/pre-hire/talent-attraction/',
                            'title': 'Talent Attraction',
                            'menu_order': 3,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        },
                        {
                            'id': 7150,
                            'url': '/pre-hire/applicant-tracking/',
                            'title': 'Applicant Tracking',
                            'menu_order': 4,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        },
                        {
                            'id': 7151,
                            'url': '/pre-hire/onboarding/',
                            'title': 'Employee Onboarding Software for Hospitality',
                            'menu_order': 5,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        },
                        {
                            'id': 10685,
                            'url': '/carri-chat-and-apply/',
                            'title': 'Carri',
                            'menu_order': 6,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        }
                    ]
                },
                {
                    'id': 7152,
                    'url': '/post-hire/',
                    'title': 'Workforce Management',
                    'menu_order': 7,
                    'object': 'page',
                    'menu_item_parent': '11098',
                    'description': 'Workforce management solutions to schedule, engage, and analyse your teams.',
                    'children': [
                        {
                            'id': 7153,
                            'url': '/post-hire/scheduling/',
                            'title': 'Scheduling',
                            'menu_order': 8,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 9699,
                            'url': '/payroll/',
                            'title': 'Payroll',
                            'menu_order': 9,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 7154,
                            'url': '/post-hire/time-attendance/',
                            'title': 'Time & Attendance',
                            'menu_order': 10,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 11585,
                            'url': '/engagement/',
                            'title': 'Engagement',
                            'menu_order': 11,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 7155,
                            'url': '/post-hire/communications/',
                            'title': 'Communications',
                            'menu_order': 12,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        }
                    ]
                },
                {
                    'id': 7156,
                    'url': '/insights-analytics/',
                    'title': 'Harri IQ',
                    'menu_order': 13,
                    'object': 'page',
                    'menu_item_parent': '11098',
                    'description': ''
                }
            ]
        },
        {
            'id': 7158,
            'url': '/partners/',
            'title': 'Partners',
            'menu_order': 14,
            'object': 'page',
            'menu_item_parent': '0',
            'description': ''
        },
        {
            'id': 8775,
            'url': 'https://resources.harri.com/',
            'title': 'Resources',
            'menu_order': 15,
            'object': 'custom',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 11286,
                    'url': 'https://resources.harri.com/events-webinars/',
                    'title': 'Events & Webinars',
                    'menu_order': 16,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11255,
                    'url': 'https://resources.harri.com/category/case-studies/',
                    'title': 'Client Stories',
                    'menu_order': 17,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11123,
                    'url': 'https://resources.harri.com/guides-ebooks/',
                    'title': 'Guides & Ebooks',
                    'menu_order': 18,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11122,
                    'url': 'https://resources.harri.com/category/blog/',
                    'title': 'Blog',
                    'menu_order': 19,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11124,
                    'url': '/harri-insider/',
                    'title': 'Harri Insider',
                    'menu_order': 20,
                    'object': 'page',
                    'menu_item_parent': '8775',
                    'description': ''
                }
            ]
        },
        {
            'id': 7159,
            'url': '/about-us/',
            'title': 'About Us',
            'menu_order': 21,
            'object': 'page',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 10830,
                    'url': '/careers',
                    'title': 'Join the Team',
                    'menu_order': 22,
                    'object': 'custom',
                    'menu_item_parent': '7159',
                    'description': ''
                }
            ]
        }
    ]
};


wpRoutes["/post-jobs?activePackages"] = {
    "enableUTM": true,
    "showGlobalSearch": false,
    "disableSSR": true,
    "name": "pricing",
    "type": "backend-frontend",
    "templateUrl": "../modules/billing/views/pricing.html",
    "data": [
        {"type": "api", "link": "payment/get_packages", 'id': 'packages'},
        {"type": "api", "link": "payment/get_subscription_packages", 'id': 'subscriptionPackages'}
    ],
    "dataMappingCallback": function (data, routeOptions, publicFunctions) {

        if (typeof (_) != 'undefined') {
            var subscription = _.map(data.subscriptionPackages.data, function (obj, key) {
                var data = obj;
                data.Package.PackageSubscription = _.groupBy(obj.Package.PackageSubscription, 'type');
                return data;
            });

            data.subscriptionPackages.data = subscription;
        }

        return {
            data: data,
            wpDynamicHeaderMenu: header
        };
    },
    "route_styles": {
        framework: "bootstrap_v4"
    },
    "headTags": prepareDefaultHeadTags(
        "Simple Pricing, Designed To Fit Your Needs",
        "Find the best fit for your team and start hiring top talent."
    )
};

wpRoutes["/workforce-compliance"] = {
    "enableUTM": true,
    "showGlobalSearch": false,
    "disableSSR": true,
    "name": "lms_compliance_training",
    "type": "backend-frontend",
    "route_styles": {
        framework: "bootstrap_v4"
    },
    "templateUrl": "../modules/landing_pages/views/2018/lms-landing-page.html",
    "controller": "LandingPageController",
    "data": [
        {"type": "api", "link": "payment/get_packages?mode=LMS", 'id': 'packages'},
    ],
    "headTags": prepareDefaultHeadTags(
        "Workforce Training Platform | Happiness in Hospitality - HARRI",
        ""
    ),
    "dataMappingCallback": function (data, routeOptions, publicFunctions) {
        return {
            data: data,
            wpDynamicHeaderMenu: header
        };
    }
};


wpRoutes['/about-us-new'] = {
    "name": "wp__about_us_new",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_about-us-new_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_about-us-new_",
            "UK:landing_uk:_about-us-new_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_about-us-new_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/about-us-new"
            }
        }
    ]
};
wpRoutes['/agentic-ai'] = {
    "name": "wp__agentic_ai",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_agentic-ai_.html",
        "uk": "../wp-pages/pages/compiled/uk/_agentic-ai_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_agentic-ai_",
            "UK:landing_uk:_agentic-ai_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_agentic-ai_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_agentic-ai_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri Agentic AI"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri Agentic AI"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "The #1 AI platform built for frontline teams, take the grind out of scheduling, compliance, and labor decisions. Put the time back into your guests and team."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "The #1 AI platform built for frontline teams, take the grind out of scheduling, compliance, and labor decisions. Put the time back into your guests and team."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/agentic-ai"
            }
        }
    ]
};
wpRoutes['/integrations-new-page-v2'] = {
    "name": "wp__integrations_new_page_v_",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_integrations-new-page-v2_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_integrations-new-page-v2_",
            "UK:landing_uk:_integrations-new-page-v2_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_integrations-new-page-v2_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/integrations-new-page-v2"
            }
        }
    ]
};
wpRoutes['/insights-analytics-new-page-v2'] = {
    "name": "wp__insights_analytics_new_page_v_",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_insights-analytics-new-page-v2_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_insights-analytics-new-page-v2_",
            "UK:landing_uk:_insights-analytics-new-page-v2_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_insights-analytics-new-page-v2_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/insights-analytics-new-page-v2"
            }
        }
    ]
};
wpRoutes['/compliance-new-page-v2'] = {
    "name": "wp__compliance_new_page_v_",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_compliance-new-page-v2_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_compliance-new-page-v2_",
            "UK:landing_uk:_compliance-new-page-v2_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_compliance-new-page-v2_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/compliance-new-page-v2"
            }
        }
    ]
};
wpRoutes['/employee-engagement-new-page-v2'] = {
    "name": "wp__employee_engagement_new_page_v_",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_employee-engagement-new-page-v2_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_employee-engagement-new-page-v2_",
            "UK:landing_uk:_employee-engagement-new-page-v2_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_employee-engagement-new-page-v2_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/employee-engagement-new-page-v2"
            }
        }
    ]
};
wpRoutes['/talent-acquisition-new-page-v2'] = {
    "name": "wp__talent_acquisition_new_page_v_",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_talent-acquisition-new-page-v2_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_talent-acquisition-new-page-v2_",
            "UK:landing_uk:_talent-acquisition-new-page-v2_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_talent-acquisition-new-page-v2_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/talent-acquisition-new-page-v2"
            }
        }
    ]
};
wpRoutes['/workforce-management-new-page-v2'] = {
    "name": "wp__workforce_management_new_page_v_",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_workforce-management-new-page-v2_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_workforce-management-new-page-v2_",
            "UK:landing_uk:_workforce-management-new-page-v2_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_workforce-management-new-page-v2_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/workforce-management-new-page-v2"
            }
        }
    ]
};
wpRoutes['/home-page-new-design-2'] = {
    "name": "wp__home_page_new_design__",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_home-page-new-design-2_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_home-page-new-design-2_",
            "UK:landing_uk:_home-page-new-design-2_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_home-page-new-design-2_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/home-page-new-design-2"
            }
        }
    ]
};
wpRoutes['/employee-engagement-new-page'] = {
    "name": "wp__employee_engagement_new_page",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_employee-engagement-new-page_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_employee-engagement-new-page_",
            "UK:landing_uk:_employee-engagement-new-page_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_employee-engagement-new-page_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/employee-engagement-new-page"
            }
        }
    ]
};
wpRoutes['/talent-acquisition-new-page'] = {
    "name": "wp__talent_acquisition_new_page",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_talent-acquisition-new-page_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_talent-acquisition-new-page_",
            "UK:landing_uk:_talent-acquisition-new-page_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_talent-acquisition-new-page_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/talent-acquisition-new-page"
            }
        }
    ]
};
wpRoutes['/workforce-management-new-page'] = {
    "name": "wp__workforce_management_new_page",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_workforce-management-new-page_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_workforce-management-new-page_",
            "UK:landing_uk:_workforce-management-new-page_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_workforce-management-new-page_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/workforce-management-new-page"
            }
        }
    ]
};
wpRoutes['/msa-copy'] = {
    "name": "wp__msa_copy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_msa-copy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_msa-copy_",
            "UK:landing_uk:_msa-copy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_msa-copy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/msa-copy"
            }
        }
    ]
};
wpRoutes['/msa'] = {
    "name": "wp__msa",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_msa_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_msa_",
            "UK:landing_uk:_msa_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_msa_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/msa"
            }
        }
    ]
};
wpRoutes['/facial-recognition-consent'] = {
    "name": "wp__facial_recognition_consent",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_facial-recognition-consent_.html",
        "uk": "../wp-pages/pages/compiled/uk/_facial-recognition-consent_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_facial-recognition-consent_",
            "UK:landing_uk:_facial-recognition-consent_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_facial-recognition-consent_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_facial-recognition-consent_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/facial-recognition-consent"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/engagement'] = {
    "name": "wp__engagement",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_engagement_.html",
        "uk": "../wp-pages/pages/compiled/uk/_engagement_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_engagement_",
            "UK:landing_uk:_engagement_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_engagement_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_engagement_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Employee Engagement and Workforce Retention Software for Hospitality | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Employee Engagement and Workforce Retention Software for Hospitality | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Reduce turnover with Harri Engage. Our tool gives you one simple place to communicate with your team, collect feedback, and build a connected culture."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Reduce turnover with Harri Engage. Our tool gives you one simple place to communicate with your team, collect feedback, and build a connected culture."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/engagement"
            }
        }
    ]
};
wpRoutes['/dmca-policy'] = {
    "name": "wp__dmca_policy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_dmca-policy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_dmca-policy_",
            "UK:landing_uk:_dmca-policy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_dmca-policy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "DMCA Policy | Harri LLC"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "DMCA Policy | Harri LLC"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "We comply with the Digital Millennium Copyright Act and provide a method for copyright owners to communicate information about alleged infringements to us, and for us to inform our users about them."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "We comply with the Digital Millennium Copyright Act and provide a method for copyright owners to communicate information about alleged infringements to us, and for us to inform our users about them."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/dmca-policy"
            }
        }
    ]
};
wpRoutes['/platform'] = {
    "name": "wp__platform",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_platform_.html",
        "uk": "../wp-pages/pages/compiled/uk/_platform_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_platform_",
            "UK:landing_uk:_platform_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_platform_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_platform_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Human Capital Management Software | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Human Capital Management Software | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri provides the world's best human capital management software, helping businesses drive performance through unparalleled employee experience."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri provides the world's best human capital management software, helping businesses drive performance through unparalleled employee experience."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/platform"
            }
        }
    ]
};
wpRoutes['/partners'] = {
    "name": "wp__partners",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_partners_.html",
        "uk": "../wp-pages/pages/compiled/uk/_partners_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_partners_",
            "UK:landing_uk:_partners_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_partners_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_partners_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Integrations & Partners for A Better Hospitality Management System | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Integrations & Partners for A Better Hospitality Management System | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "See our trusted partners solutions that serve the hospitality space. Easily connect with restaurant management systems, POS, payroll, job boards and more."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "See our trusted partners solutions that serve the hospitality space. Easily connect with restaurant management systems, POS, payroll, job boards and more."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/partners"
            }
        }
    ]
};
wpRoutes['/carri-request-a-demo'] = {
    "name": "wp__carri_request_a_demo",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_carri-request-a-demo_.html",
        "uk": "../wp-pages/pages/compiled/uk/_carri-request-a-demo_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_carri-request-a-demo_",
            "UK:landing_uk:_carri-request-a-demo_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_carri-request-a-demo_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_carri-request-a-demo_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Carri Request A Demo"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Carri Request A Demo"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "So much more than a chatbot, Carri revolutionizes the candidate experience with mobile-driven conversational AI to acquire quality candidates, faster."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "So much more than a chatbot, Carri revolutionizes the candidate experience with mobile-driven conversational AI to acquire quality candidates, faster."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/carri-request-a-demo"
            }
        }
    ]
};
wpRoutes['/scheduling'] = {
    "name": "wp__scheduling",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_scheduling_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_scheduling_",
            "UK:landing_uk:_scheduling_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_scheduling_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "The Best Intelligent Employee Scheduling Software | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "The Best Intelligent Employee Scheduling Software | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Discover Harri's intelligent scheduling software for restaurants and hotels. Streamline labor management and enhance employee scheduling with Harri's all-in-one platform."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Discover Harri's intelligent scheduling software for restaurants and hotels. Streamline labor management and enhance employee scheduling with Harri's all-in-one platform."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/scheduling"
            }
        }
    ]
};
wpRoutes['/request-a-demo'] = {
    "name": "wp__request_a_demo",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_request-a-demo_.html",
        "uk": "../wp-pages/pages/compiled/uk/_request-a-demo_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_request-a-demo_",
            "UK:landing_uk:_request-a-demo_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_request-a-demo_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_request-a-demo_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Request a Demo: Hospitality Workforce Management Platform | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Request a Demo: Hospitality Workforce Management Platform | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/request-a-demo"
            }
        }
    ]
};
wpRoutes['/opt-in-thank-you'] = {
    "name": "wp__opt_in_thank_you",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_opt-in-thank-you_.html",
        "uk": "../wp-pages/pages/compiled/uk/_opt-in-thank-you_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_opt-in-thank-you_",
            "UK:landing_uk:_opt-in-thank-you_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_opt-in-thank-you_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_opt-in-thank-you_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/opt-in-thank-you"
            }
        }
    ]
};
wpRoutes['/intelligent-scheduling-for-the-workforce'] = {
    "name": "wp__intelligent_scheduling_for_the_workforce",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_intelligent-scheduling-for-the-workforce_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_intelligent-scheduling-for-the-workforce_",
            "UK:landing_uk:_intelligent-scheduling-for-the-workforce_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_intelligent-scheduling-for-the-workforce_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: COVID-19 Screening Technology for Schools & Universities"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: COVID-19 Screening Technology for Schools & Universities"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Implement COVID-19 symptoms screening technology for Schools & Universities to prevent the spread of the coronavirus on campus and in the classroom."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Implement COVID-19 symptoms screening technology for Schools & Universities to prevent the spread of the coronavirus on campus and in the classroom."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/5cfe3681ec03d635e2c68bdc6ec98bd4.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/intelligent-scheduling-for-the-workforce"
            }
        }
    ]
};
wpRoutes['/labor-compliance'] = {
    "name": "wp__labor_compliance",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_labor-compliance_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_labor-compliance_",
            "UK:landing_uk:_labor-compliance_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_labor-compliance_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Hospitality Labor Compliance Software"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Hospitality Labor Compliance Software"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri is the ultimate labor compliance software for restaurants, hotels, and all hospitality businesses. We make compliance easy, so you can focus on what you do best."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri is the ultimate labor compliance software for restaurants, hotels, and all hospitality businesses. We make compliance easy, so you can focus on what you do best."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/labor-compliance"
            }
        }
    ]
};
wpRoutes['/end-to-end-platform-for-coffee-concepts'] = {
    "name": "wp__end_to_end_platform_for_coffee_concepts",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_end-to-end-platform-for-coffee-concepts_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_end-to-end-platform-for-coffee-concepts_",
            "UK:landing_uk:_end-to-end-platform-for-coffee-concepts_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_end-to-end-platform-for-coffee-concepts_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: The First HCM Platform Built for Coffee Concepts"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: The First HCM Platform Built for Coffee Concepts"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri is helping Coffee Concepts to transform their HR and Operations practices in the new normal. Focused on the employee experience. Driven by data."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri is helping Coffee Concepts to transform their HR and Operations practices in the new normal. Focused on the employee experience. Driven by data."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/end-to-end-platform-for-coffee-concepts"
            }
        }
    ]
};
wpRoutes['/payroll'] = {
    "name": "wp__payroll",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_payroll_.html",
        "uk": "../wp-pages/pages/compiled/uk/_payroll_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_payroll_",
            "UK:landing_uk:_payroll_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_payroll_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_payroll_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/payroll"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/kickstart-hospitality-unite'] = {
    "name": "wp__kickstart_hospitality_unite",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_kickstart-hospitality-unite_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_kickstart-hospitality-unite_",
            "UK:landing_uk:_kickstart-hospitality-unite_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_kickstart-hospitality-unite_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/kickstart-hospitality-unite"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/privacy-hujobs'] = {
    "name": "wp__privacy_hujobs",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_privacy-hujobs_.html",
        "uk": "../wp-pages/pages/compiled/uk/_privacy-hujobs_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_privacy-hujobs_",
            "UK:landing_uk:_privacy-hujobs_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_privacy-hujobs_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_privacy-hujobs_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/privacy-hujobs"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/harri-insider'] = {
    "name": "wp__harri_insider",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_harri-insider_.html",
        "uk": "../wp-pages/pages/compiled/uk/_harri-insider_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_harri-insider_",
            "UK:landing_uk:_harri-insider_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_harri-insider_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_harri-insider_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri Insider: One Source of Hospitality Talent Management News"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri Insider: One Source of Hospitality Talent Management News"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Receive actionable insights, research, content, and news that cover all aspects of building, managing, and engaging your greatest resource. Your team."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Receive actionable insights, research, content, and news that cover all aspects of building, managing, and engaging your greatest resource. Your team."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/da33571f33f657050f6bb1a3c3ba2b2a.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/harri-insider"
            }
        }
    ]
};
wpRoutes['/care-sector'] = {
    "name": "wp__care_sector",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_care-sector_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_care-sector_",
            "UK:landing_uk:_care-sector_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_care-sector_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/care-sector"
            }
        }
    ]
};
wpRoutes['/grocery'] = {
    "name": "wp__grocery",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_grocery_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_grocery_",
            "UK:landing_uk:_grocery_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_grocery_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Talent Acquisition Solutions for Grocery"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Talent Acquisition Solutions for Grocery"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "End-to-End talent solutions built for grocery businesses to source, attract, and hire the best talent. Technology your teams will love."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "End-to-End talent solutions built for grocery businesses to source, attract, and hire the best talent. Technology your teams will love."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/grocery"
            }
        }
    ]
};
wpRoutes['/hospitality-unite'] = {
    "name": "wp__hospitality_unite",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_hospitality-unite_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_hospitality-unite_",
            "UK:landing_uk:_hospitality-unite_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_hospitality-unite_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Find or post a job in retail, grocery, delivery, care sectors. Free of charge."
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Find or post a job in retail, grocery, delivery, care sectors. Free of charge."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "We’re on a mission to help the millions of displaced workers in service industries find employment in retail, grocery, delivery, care, and many other sectors experiencing a surge in hiring. Join us, on this non-profit initiative."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "We’re on a mission to help the millions of displaced workers in service industries find employment in retail, grocery, delivery, care, and many other sectors experiencing a surge in hiring. Join us, on this non-profit initiative."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/hospitality-unite"
            }
        }
    ]
};
wpRoutes['/partner-with-us'] = {
    "name": "wp__partner_with_us",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_partner-with-us_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_partner-with-us_",
            "UK:landing_uk:_partner-with-us_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_partner-with-us_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Partner With Us"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Partner With Us"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "You've built technology that's changed the world of hospitality for the better. We've got hundreds of clients eager to do their jobs more efficiently. Partner with Harri so we can shape the future of work in restaurants and hotels, together."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "You've built technology that's changed the world of hospitality for the better. We've got hundreds of clients eager to do their jobs more efficiently. Partner with Harri so we can shape the future of work in restaurants and hotels, together."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/partner-with-us"
            }
        }
    ]
};
wpRoutes['/thank-you'] = {
    "name": "wp__thank_you",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_thank-you_.html",
        "uk": "../wp-pages/pages/compiled/uk/_thank-you_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_thank-you_",
            "UK:landing_uk:_thank-you_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_thank-you_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_thank-you_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/thank-you"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/compliance'] = {
    "name": "wp__compliance",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_compliance_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_compliance_",
            "UK:landing_uk:_compliance_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_compliance_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Compliance Management System and Workforce Training Platform | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Compliance Management System and Workforce Training Platform | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "With our automated compliance tools, you can detect labor risks and automate workflows to avoid costly fines. Built specifically for hospitality operators."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "With our automated compliance tools, you can detect labor risks and automate workflows to avoid costly fines. Built specifically for hospitality operators."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/compliance"
            }
        }
    ]
};
wpRoutes['/insights-analytics'] = {
    "name": "wp__insights_analytics",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_insights-analytics_.html",
        "uk": "../wp-pages/pages/compiled/uk/_insights-analytics_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_insights-analytics_",
            "UK:landing_uk:_insights-analytics_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_insights-analytics_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_insights-analytics_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Transform Hospitality Data into Actionable Insights | Harri IQ Analytics"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Transform Hospitality Data into Actionable Insights | Harri IQ Analytics"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Transform your decision-making with Harri IQ. Get a single, comprehensive view of your data to quickly identify compliance risks and act with confidence."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Transform your decision-making with Harri IQ. Get a single, comprehensive view of your data to quickly identify compliance risks and act with confidence."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/insights-analytics"
            }
        }
    ]
};
wpRoutes['/post-hire'] = {
    "name": "wp__post_hire",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_post-hire_.html",
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_post-hire_",
            "UK:landing_uk:_post-hire_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_post-hire_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Workforce Management Technology Solutions & Software for Hospitality | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Workforce Management Technology Solutions & Software for Hospitality | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Make smarter schedules faster with agentic AI powered workforce management. Predict demand and deploy labor profitably on one platform built for hospitality."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Make smarter schedules faster with agentic AI powered workforce management. Predict demand and deploy labor profitably on one platform built for hospitality."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire"
            }
        }
    ]
};
wpRoutes['/pre-hire'] = {
    "name": "wp__pre_hire",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_pre-hire_.html",
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_pre-hire_",
            "UK:landing_uk:_pre-hire_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_pre-hire_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Talent Acquisition Software | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Talent Acquisition Software | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Hire great teams faster with Harri's AI-powered talent acquisition. We help you attract, screen, and hire top talent for your hospitality business."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Hire great teams faster with Harri's AI-powered talent acquisition. We help you attract, screen, and hire top talent for your hospitality business."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire"
            }
        }
    ]
};
wpRoutes['/privacy'] = {
    "name": "wp__privacy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_privacy_.html",
        "uk": "../wp-pages/pages/compiled/uk/_privacy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_privacy_",
            "UK:landing_uk:_privacy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_privacy_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_privacy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri Privacy Policy and Fair Processing Notice - US"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri Privacy Policy and Fair Processing Notice - US"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri's Privacy Policy outlines how we collect, use, and protect your personal data. Stay informed about your privacy rights and our practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri's Privacy Policy outlines how we collect, use, and protect your personal data. Stay informed about your privacy rights and our practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/privacy"
            }
        }
    ]
};
wpRoutes['/terms'] = {
    "name": "wp__terms",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_terms_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_terms_",
            "UK:landing_uk:_terms_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_terms_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/terms"
            }
        }
    ]
};
wpRoutes['/cookie-policy'] = {
    "name": "wp__cookie_policy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_cookie-policy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_cookie-policy_",
            "UK:landing_uk:_cookie-policy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_cookie-policy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri Website Cookie Policy - US"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri Website Cookie Policy - US"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Understand how Harri uses cookies to enhance your website experience. Read our cookie policy for details on data collection and user preferences."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Understand how Harri uses cookies to enhance your website experience. Read our cookie policy for details on data collection and user preferences."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/cookie-policy"
            }
        }
    ]
};
wpRoutes['/about-us'] = {
    "name": "wp__about_us",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_about-us_.html",
        "uk": "../wp-pages/pages/compiled/uk/_about-us_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_about-us_",
            "UK:landing_uk:_about-us_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_about-us_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_about-us_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "About Us: Hospitality Software for a Better Employee Experience"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "About Us: Hospitality Software for a Better Employee Experience"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri is the global leader in frontline employee experience technology for hospitality, helping businesses recruit, manage, and engage top talent worldwide."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri is the global leader in frontline employee experience technology for hospitality, helping businesses recruit, manage, and engage top talent worldwide."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/about-us"
            }
        }
    ]
};
wpRoutes['/'] = {
    "name": "homepage",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_.html",
        "uk": "../wp-pages/pages/compiled/uk/_.html"
    },
    "returnToOnLogin": true,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:global",
            "UK:landing_uk:global",
            "!UK:landing_default:_",
            "UK:landing_uk:_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri - HCM & Workforce Management Technology for Service Industries"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri - HCM & Workforce Management Technology for Service Industries"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri’s powerful HCM technology helps enterprise restaurants, hotels, and retailers to transform their HR and Operations practices in the new normal."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri’s powerful HCM technology helps enterprise restaurants, hotels, and retailers to transform their HR and Operations practices in the new normal."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063713/assets/80c8168da2a56f4ea37cfb89358d97d5.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/"
            }
        }
    ]
};
wpRoutes['/request-a-demo-sandbox'] = {
    "name": "wp__request_a_demo_sandbox",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_request-a-demo-sandbox_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_request-a-demo-sandbox_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_request-a-demo-sandbox_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Request a Demo: Hospitality Workforce Management Platform | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Request a Demo: Hospitality Workforce Management Platform | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/request-a-demo-sandbox"
            }
        }
    ]
};
wpRoutes['/carri-chat-and-apply'] = {
    "name": "wp__carri_chat_and_apply",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_carri-chat-and-apply_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_carri-chat-and-apply_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_carri-chat-and-apply_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Carri - Conversational AI for Hospitality Powered by Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Carri - Conversational AI for Hospitality Powered by Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Revolutionise the hiring experience with Carri. Conversational AI built to streamline hiring and humanise the application journey."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Revolutionise the hiring experience with Carri. Conversational AI built to streamline hiring and humanise the application journey."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20251022063705/assets/852750691d40b672f0bac1551bfcfc8b.jpg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/carri-chat-and-apply"
            }
        }
    ]
};
wpRoutes['/post-hire/communications'] = {
    "name": "wp__post_hire_communications",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_communications_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_post-hire_communications_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_communications_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Streamline Employee Communication with Harri's Post-Hire Solutions | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Streamline Employee Communication with Harri's Post-Hire Solutions | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Boost post-hire communication with Harri's solutions. Improve engagement, streamline onboarding, and enhance retention. Discover more!"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Boost post-hire communication with Harri's solutions. Improve engagement, streamline onboarding, and enhance retention. Discover more!"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire/communications"
            }
        }
    ]
};
wpRoutes['/post-hire/time-attendance'] = {
    "name": "wp__post_hire_time_attendance",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_time-attendance_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_post-hire_time-attendance_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_time-attendance_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Workplace Management: Timekeeping, Compliance, and Employee Engagement | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Workplace Management: Timekeeping, Compliance, and Employee Engagement | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri’s hospitality-focused attendance software monitors employee time accurately. Eliminate time theft, enhance compliance, and engage staff with secure biometric clock-ins."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri’s hospitality-focused attendance software monitors employee time accurately. Eliminate time theft, enhance compliance, and engage staff with secure biometric clock-ins."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire/time-attendance"
            }
        }
    ]
};
wpRoutes['/post-hire/scheduling'] = {
    "name": "wp__post_hire_scheduling",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_scheduling_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_post-hire_scheduling_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_scheduling_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Employee Scheduling Software for Efficient Workforce Management | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Employee Scheduling Software for Efficient Workforce Management | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Scheduling software for employee management. Simplify labor-compliant schedules, enhance operations, and boost productivity. Request a demo today."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Scheduling software for employee management. Simplify labor-compliant schedules, enhance operations, and boost productivity. Request a demo today."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire/scheduling"
            }
        }
    ]
};
wpRoutes['/pre-hire/onboarding'] = {
    "name": "wp__pre_hire_onboarding",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_onboarding_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_pre-hire_onboarding_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_onboarding_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "HR New Employee Onboarding Software for Hospitality | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "HR New Employee Onboarding Software for Hospitality | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Employee onboarding has never been easier with our dedicated hospitality software solution. Seamlessly onboard new hires with mobile-friendly forms, two-way document uploads for new starters, and more."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Employee onboarding has never been easier with our dedicated hospitality software solution. Seamlessly onboard new hires with mobile-friendly forms, two-way document uploads for new starters, and more."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire/onboarding"
            }
        }
    ]
};
wpRoutes['/pre-hire/applicant-tracking'] = {
    "name": "wp__pre_hire_applicant_tracking",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_applicant-tracking_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_pre-hire_applicant-tracking_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_applicant-tracking_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Applicant Tracking System for Restaurants, Hotels, Franchises & Hospitality | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Applicant Tracking System for Restaurants, Hotels, Franchises & Hospitality | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri is the all-in-one solution built for restaurants, franchises and hospitality businesses to manage candidate applications, conduct interviews and automate the hiring process. Attract, interview and hire qualified candidates efficiently with one integrated platform."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri is the all-in-one solution built for restaurants, franchises and hospitality businesses to manage candidate applications, conduct interviews and automate the hiring process. Attract, interview and hire qualified candidates efficiently with one integrated platform."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire/applicant-tracking"
            }
        }
    ]
};
wpRoutes['/pre-hire/talent-attraction'] = {
    "name": "wp__pre_hire_talent_attraction",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_talent-attraction_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_pre-hire_talent-attraction_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_talent-attraction_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "The Talent Attraction Platform for the Hospitality Industry | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "The Talent Attraction Platform for the Hospitality Industry | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri offers the most effective talent attraction tools for hospitality. Our solutions distribute open positions to millions of active job seekers in seconds."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri offers the most effective talent attraction tools for hospitality. Our solutions distribute open positions to millions of active job seekers in seconds."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire/talent-attraction"
            }
        }
    ]
};
wpRoutes['body-prefi'] = {
    "name": "wp_body_prefi",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/body-prefix.html",
        "uk": "../wp-pages/pages/compiled/uk/body-prefix.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:body-prefix",
            "UK:landing_uk:body-prefix"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/body-prefix.html",
                    "uk": "../wp-pages/pages/compiled/uk/body-prefix.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {}
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.combody-prefi"
            }
        }
    ]
};
wpRoutes['body-appendi'] = {
    "name": "wp_body_appendi",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/body-appendix.html",
        "uk": "../wp-pages/pages/compiled/uk/body-appendix.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:body-appendix",
            "UK:landing_uk:body-appendix"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/body-appendix.html",
                    "uk": "../wp-pages/pages/compiled/uk/body-appendix.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {}
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.combody-appendi"
            }
        }
    ]
};

try {
    wpRoutes['/']["route_dependencies"] = wpRoutes['/']["route_dependencies"] || [];
    wpRoutes['/']["route_dependencies"].push({
        type: 'chunk',
        loader: function () {
            return import('../hmodules/harri-main/harri-main.module.js');
        }
    });
    publicConfiguration['routes'] = _.extend(publicConfiguration['routes'], wpRoutes);
} catch (e) {
}

try {
    module.exports = wpRoutes;
} catch (e) {

}

